module.exports = __webpack_public_path__ + "static/media/logo.5f82e824.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/logo.png
// module id = 888
// module chunks = 0